import React from 'react';
import { connect } from 'react-redux'
import styles from './MessageHistoryTab.module.css'

class MessageHistoryTab extends React.Component {
    render() {
        return (
            <div className={styles.wrapper}>
                {this.props.messageHistory && this.props.messageHistory.length > 0 ? Object.keys(this.props.messageHistory)
                    .map(key => {
                        const historyEntry = this.props.messageHistory[key];
                        return <div key={historyEntry.id} style={{ paddingTop: '10px' }}>
                            <div style={{ paddingLeft: '5px', backgroundColor: '#cceff9' }}>{new Date(historyEntry.msgDate).toLocaleString("en-US") + " - " + historyEntry.msgType + " by "+ historyEntry.msgUser }</div>
                            <div style={{ paddingLeft: '15px', paddingTop: '10px' }}>{historyEntry.details}</div>
                        </div>
                    }) : <span><i>No Messages</i></span>
                }
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        messageHistory: Object.keys(state.entities.notesReqApprovalMsgs)
            .filter(key => { return state.entities.notesReqApprovalMsgs[key].noteId === state.entities.notesReqApproval[state.ui.notesReqApproval.selectedMessage].id; })
            .sort((a, b) => new Date(state.entities.notesReqApprovalMsgs[b].msgDate) - new Date(state.entities.notesReqApprovalMsgs[a].msgDate))
            .map(key => state.entities.notesReqApprovalMsgs[key])
    };
}

const connectedMessageHistoryTab = connect(mapStateToProps)(MessageHistoryTab);
export { connectedMessageHistoryTab as MessageHistoryTab };
